import { createContext } from "react";
import { CountryCodeEnum } from "../models/enums/countryCodeEnum";

export type BoatCountryCodesMap = { [boatId: number]: CountryCodeEnum | undefined };
export interface BoatCountryCodesContextState {
    boatCountryCodes: BoatCountryCodesMap;
    isLoading: boolean;
}
export const BoatCountryCodesContext = createContext<BoatCountryCodesContextState>({boatCountryCodes: {}, isLoading: false});
